// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2eIUm","label":"Category_label__181zz","content":"Category_content__1aVNJ","header":"Category_header__2rsfw","location":"Category_location__2gX1J"};